"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameInput = void 0;
const ControllerManager_1 = require("./Managers/ControllerManager");
const KeyboardSystem_1 = require("./Systems/Controllers/KeyboardSystem");
const MouseSystem_1 = require("./Systems/Controllers/MouseSystem");
class GameInput {
    constructor(mappedInputStates, disableOpts) {
        this.updateController = () => [];
        this.updateKeyboard = () => null;
        this.updateTouch = () => null;
        this.updateMouse = () => null;
        disableOpts = disableOpts || {};
        !disableOpts.keyboard && this.initializeKeyboardSystem(mappedInputStates === null || mappedInputStates === void 0 ? void 0 : mappedInputStates.keyboard);
        !disableOpts.mouse && this.initializeMouseManager();
        !disableOpts.controller && this.initializeControllerManager(mappedInputStates.controller);
        //   !disableOpts.touch && this.initializeTouchManager();
    }
    update() {
        return {
            keyboard: this.updateKeyboard(),
            mouse: this.updateMouse(),
            controller: this.updateController(),
            touch: this.updateTouch(),
        };
    }
    unmapKeyboardAction(action, key) {
        this.keyboardSystem.unmapInputFromAction(key, action);
    }
    mapKeyboardAction(action, key) {
        this.keyboardSystem.mapInputIdToAction(key, action);
    }
    mapController(controllerIndex, id) {
        // this.controllerManager.initializedSystemArray
    }
    updateOnlyTouch() {
    }
    registerSystemHandlers(system) {
    }
    initializeKeyboardSystem(state) {
        this.keyboardSystem = new KeyboardSystem_1.KeyboardSystem(state);
        this.updateKeyboard = this.keyboardSystem.update.bind(this.keyboardSystem);
    }
    initializeTouchManager(factory) {
        this.touchSystem = factory();
        //this.touchManager = new KeyboardManager();
        this.updateTouch = this.touchSystem.update.bind(this.touchSystem);
    }
    initializeMouseManager(state) {
        this.mouseSystem = new MouseSystem_1.MouseSystem(state);
        this.updateMouse = this.mouseSystem.update.bind(this.mouseSystem);
    }
    initializeControllerManager(state) {
        this.controllerManager = new ControllerManager_1.ControllerManager(state);
        this.controllerManager.on('add', (system) => {
            //console.error('ADDED CONTROLLER SYSTEM:', system)
        });
        this.controllerManager.on('remove', (system) => {
        });
        this.controllerManager.init();
        this.updateController = this.controllerManager.update.bind(this.controllerManager);
    }
}
exports.GameInput = GameInput;
//# sourceMappingURL=module.js.map